define([
    "angular",
    "../nlgTemplate/nlgTemplate",
    "../templateFactory/templateFactory",
    "../nlgTableDynamicColumns/nlgTableDynamicColumns"
], function(angular){
    "use strict";

    return angular.module("nlgTableModule", ["nlgTemplateModule", "templateFactoryModule", "nlgTableDynamicColumnsModule"]);
});